"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.equipmentController = void 0;
const ft_types_1 = require("@rivison-inc/ft-types");
const ServiceController_1 = require("../ServiceController");
const DateController_1 = require("../DateController");
const moment_1 = __importDefault(require("moment"));
const array_1 = require("../../utils/array");
/**
 * Controller for equipment
 */
class EquipmentController {
    /**
     * Get next dates for all services on a single piece of equipment
     * These services rely on each other so they must all be passed in
     */
    getEquipmentDue(equipment, serviceMonths, timeZone, options) {
        const filteredEquipment = equipment.filter((equipmentItem) => {
            if (options === null || options === void 0 ? void 0 : options.accountForCouldNotService) {
                const couldNotService = this.checkIfCouldNotServiceRecently(equipmentItem.history || [], timeZone, { today: options.today });
                if (couldNotService) {
                    return false;
                }
            }
            const hasOpenDeficiencies = (equipmentItem.deficiencies || []).some(deficiency => !deficiency.dateClosed);
            if (hasOpenDeficiencies) {
                return true;
            }
            const serviceMonth = serviceMonths.find(serviceMonth => { var _a; return serviceMonth.serviceMonthCategoryId === ((_a = equipmentItem.equipmentType) === null || _a === void 0 ? void 0 : _a.serviceMonthCategoryId); });
            const performedServicesWithNextDates = ServiceController_1.serviceController.getServiceNextDatesForEquipment(equipmentItem.serviceDefs || [], equipmentItem.performedServices || [], equipmentItem, timeZone, serviceMonth);
            const inspections = equipmentItem.serviceDefs || [];
            const performedServicesByTypeId = array_1.createHashMap(performedServicesWithNextDates, 'serviceTypeId');
            const filteredInspections = inspections.filter((inspectionServiceDef) => {
                const performedService = performedServicesByTypeId[inspectionServiceDef.id];
                if (!performedService) {
                    return false; // unscheduled
                }
                const nextDateFromScheduled = performedService.nextDateFromScheduled;
                const fieldData = equipmentItem.fieldData || {};
                return ServiceController_1.serviceController.isDue(inspectionServiceDef, nextDateFromScheduled, fieldData, performedService.equipmentFieldData || {}, timeZone, options === null || options === void 0 ? void 0 : options.today);
            });
            return filteredInspections.length > 0;
        });
        return filteredEquipment;
    }
    /**
     * Used when performing a service to update the
     * last date and create a history record
     */
    getEquipmentDueForInspection(equipment, serviceMonths, timeZone, options) {
        // console.log('meow 2')
        if (!timeZone) {
            return [];
        }
        // console.log('meow 3')
        const filteredEquipment = equipment.filter((equipmentItem) => {
            // console.log('meow 4')
            if (options === null || options === void 0 ? void 0 : options.accountForCouldNotService) {
                // console.log('meow 5')
                const couldNotService = this.checkIfCouldNotServiceRecently(equipmentItem.history || [], timeZone, { today: options.today });
                // console.log('meow 6',couldNotService)
                if (couldNotService) {
                    return false;
                }
            }
            // console.log('meow 7')
            const serviceMonth = serviceMonths.find(serviceMonth => { var _a; return serviceMonth.serviceMonthCategoryId === ((_a = equipmentItem.equipmentType) === null || _a === void 0 ? void 0 : _a.serviceMonthCategoryId); });
            const performedServicesWithNextDates = ServiceController_1.serviceController.getServiceNextDatesForEquipment(equipmentItem.serviceDefs || [], equipmentItem.performedServices || [], equipmentItem, timeZone, serviceMonth);
            const performedServicesByTypeId = array_1.createHashMap(performedServicesWithNextDates, 'serviceTypeId');
            const hasDueInspections = (equipmentItem.serviceDefs || []).some((inspectionServiceDef) => {
                if (inspectionServiceDef.inspection && equipmentItem.id === 'aaa-461212') {
                    console.log('meow 2', equipmentItem.id, inspectionServiceDef);
                }
                if (!inspectionServiceDef.inspection) {
                    return false;
                }
                const performedService = performedServicesByTypeId[inspectionServiceDef.id];
                const nextDateFromScheduled = performedService.nextDateFromScheduled;
                const fieldData = equipmentItem.fieldData || {};
                if (inspectionServiceDef.inspection && equipmentItem.id === 'aaa-461212') {
                    console.log('meow 3', equipmentItem.id, inspectionServiceDef, nextDateFromScheduled, fieldData, performedService.equipmentFieldData || {}, timeZone, options === null || options === void 0 ? void 0 : options.today);
                }
                return ServiceController_1.serviceController.isDue(inspectionServiceDef, nextDateFromScheduled, fieldData, performedService.equipmentFieldData || {}, timeZone, options === null || options === void 0 ? void 0 : options.today);
            });
            // console.log('meow 8',hasDueInspections,equipmentItem.serviceDefs)
            return hasDueInspections;
        });
        return filteredEquipment;
    }
    /**
     * Get next dates for all services on a single peice of equipment
     * These services rely on each other so they must all be passed in
     */
    getEquipmentDueForService(equipment, serviceMonths, timeZone, options) {
        if (!timeZone) {
            return [];
        }
        const filteredEquipment = equipment.filter((equipmentItem) => {
            if (options === null || options === void 0 ? void 0 : options.accountForCouldNotService) {
                const couldNotService = this.checkIfCouldNotServiceRecently(equipmentItem.history || [], timeZone, { today: options.today });
                if (couldNotService) {
                    return false;
                }
            }
            const hasOpenDeficiencies = (equipmentItem.deficiencies || []).some(deficiency => !deficiency.dateClosed);
            if (hasOpenDeficiencies) {
                return true;
            }
            const serviceMonth = serviceMonths.find(serviceMonth => { var _a; return serviceMonth.serviceMonthCategoryId === ((_a = equipmentItem.equipmentType) === null || _a === void 0 ? void 0 : _a.serviceMonthCategoryId); });
            const performedServicesWithNextDates = ServiceController_1.serviceController.getServiceNextDatesForEquipment(equipmentItem.serviceDefs || [], equipmentItem.performedServices || [], equipmentItem, timeZone, serviceMonth);
            const performedServicesByTypeId = array_1.createHashMap(performedServicesWithNextDates, 'serviceTypeId');
            const hasDueServices = (equipmentItem.serviceDefs || []).some((serviceDef) => {
                if (serviceDef.inspection || serviceDef.unscheduled) {
                    return false;
                }
                const performedService = performedServicesByTypeId[serviceDef.id];
                const nextDateFromScheduled = performedService.nextDateFromScheduled;
                const fieldData = equipmentItem.fieldData || {};
                return ServiceController_1.serviceController.isDue(serviceDef, nextDateFromScheduled, fieldData, performedService.equipmentFieldData || {}, timeZone, options === null || options === void 0 ? void 0 : options.today);
            });
            return hasDueServices;
        });
        return filteredEquipment;
    }
    checkIfCouldNotServiceRecently(historyRecords, timeZone, options) {
        const today = moment_1.default((options === null || options === void 0 ? void 0 : options.today) || undefined).tz(timeZone).startOf('day').toISOString();
        const threshold = moment_1.default().tz(timeZone).add(1, 'day').endOf('day').toISOString();
        const hasRecordsWithinRange = historyRecords.some((historyRecord) => {
            if (!historyRecord.date || historyRecord.type != ft_types_1.HistoryType.COULD_NOT_SERVICE) { // do not change this to a hard equal
                return false;
            }
            return DateController_1.dateController.isSame(historyRecord.date, today, ft_types_1.FrequencyType.DAY, timeZone) || (DateController_1.dateController.isAfter(historyRecord.date, today, ft_types_1.FrequencyType.DAY, timeZone) && DateController_1.dateController.isBefore(historyRecord.date, threshold, ft_types_1.FrequencyType.DAY, timeZone));
        });
        return Boolean(hasRecordsWithinRange);
    }
}
exports.equipmentController = new EquipmentController();
